module.exports = __webpack_public_path__ + "static/media/panel1.9b630aac.svg";